import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const publictionApiSlice = createApi({
  reducerPath: 'PublicationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API_BASE_URL,
  }),
  endpoints: (builder) => ({
    getUsers: builder.query({
    query: () => '/publictions/all',
    }),
  }),
});

export const { useGetPublicationsQuery } = publictionApiSlice;
